import React, { useState, useEffect } from 'react';
import { User, LogIn } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';

const TopBar = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const currentUser = authService.getCurrentUser();
    setUser(currentUser);
  }, []);

  const handleLogout = () => {
    authService.logout();
    setUser(null);
    window.location.href = '/';
  };

  const isLoggedIn = authService.isAuthenticated();

  return (
    <div className="sticky top-0 z-40 bg-white/80 backdrop-blur-lg border-b border-gray-200 px-4 md:px-8 py-3 md:py-4">
      <div className="flex items-center justify-between">
        {/* Mobile Logo */}
        <div className="md:hidden">
          <img 
            src="https://customer-assets.emergentagent.com/job_worship-tracks-5/artifacts/twg4kldp_LOGO%20Iglesia%202.png" 
            alt="Tu Iglesia App" 
            className="h-10"
          />
        </div>

        <div className="flex-1 hidden md:block">
          {/* Desktop breadcrumb or navigation */}
        </div>

        {/* User Profile / Login Button */}
        <div className="flex items-center gap-2">
          {!isLoggedIn ? (
            <button
              onClick={() => navigate('/auth')}
              className="flex items-center gap-2 px-4 md:px-6 py-2 md:py-2.5 bg-gradient-to-r from-[#00CCFF] to-[#056A84] text-white font-bold rounded-full hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl text-sm md:text-base"
            >
              <LogIn size={18} className="md:w-5 md:h-5" />
              <span className="hidden sm:inline">Iniciar Sesión</span>
            </button>
          ) : (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="flex items-center gap-2 md:gap-3 px-3 md:px-4 py-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-all duration-300 border border-gray-200">
                  <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gradient-to-r from-[#00CCFF] to-[#056A84] flex items-center justify-center text-white font-bold shadow-md text-sm md:text-base">
                    {user?.name ? user.name[0].toUpperCase() : 'U'}
                  </div>
                  <span className="font-semibold text-gray-900 text-sm md:text-base hidden sm:inline">
                    {user?.name || 'Usuario'}
                  </span>
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuItem onClick={() => navigate('/profile')}>
                  <User className="mr-2 h-4 w-4" />
                  <span>Mi Perfil</span>
                </DropdownMenuItem>
                {user?.role === 'admin' && (
                  <DropdownMenuItem onClick={() => navigate('/admin')}>
                    <span className="mr-2">⚙️</span>
                    <span>Panel Admin</span>
                  </DropdownMenuItem>
                )}
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={handleLogout}>
                  Cerrar Sesión
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
